// src/components/DynamicTable.tsx
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  IconButton
} from '@mui/material';
import Pagination from './Pagination';
import { themeColors } from '../theme';
import EditIcon from '@mui/icons-material/Edit';
import PauseIcon from '@mui/icons-material/Pause';
import DeleteIcon from '@mui/icons-material/Delete';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface DynamicTableProps {
  headers: any;
  data: { [key: string]: any }[];
  onEdit: any;
  onStatusChange: any;
  onVerify:any;
  onFBVerify:any;
  onDelete: any;
  page: any;
  setPage: any;
  pageSize: any;
  setPageSize: any;
  count: any;
  showVerify:any;
  integrationTypeNumber:any,
  pannel?:any
}

const DynamicTable: React.FC<DynamicTableProps> = ({ headers, data, onEdit, onStatusChange,onVerify,onFBVerify,onDelete,page,setPage,pageSize,setPageSize,count,showVerify,integrationTypeNumber ,pannel}) => {
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event: unknown, newPage: number) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // const slicedData = data.slice(page * pageSize, page * pageSize + pageSize);
  const preview = (url:any) => { // Replace with your desired URL format
    window.open(url, '_blank');
  };
  return (
    <Paper sx={{ width: "100%", height: "90%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <TableContainer sx={{ height: "80%" }}>
        <Table>
          <TableHead sx={{ backgroundColor: themeColors.thBackgroundColor }}>
            <TableRow>
              {pannel?(headers.map((header:any) => (
                <TableCell key={header.header}>{header.header}</TableCell>
              ))):(headers.map((header:any) => (
                <TableCell key={header}>{header}</TableCell>
              )))}
              <Box />
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: themeColors.tdBackgroundColor }}>
            {data.map((row, rowIndex) => (
              // console.log("row",row["Sheet ID"])
              <TableRow key={rowIndex}>

{pannel?(headers.map((header:any) => (
                <TableCell key={header.value}>{`${row[header.value]}`}</TableCell>
              ))):(headers.map((header:any) => (
                <TableCell key={header}>{row[header]}</TableCell>
              )))}
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    {/* Always show Edit and Delete */}
    <IconButton aria-label="edit integration" onClick={() => onEdit(row)}>
      <EditIcon />
    </IconButton>

    <IconButton aria-label="delete integration" onClick={() => {pannel?onDelete(row["_id"]):onDelete(row["Integration Name"])}}>
      <DeleteIcon />
    </IconButton>

    {/* Show rest only if pannel is not true */}
    {!pannel && (
      <>
        {integrationTypeNumber == 0 && (
          <IconButton aria-label="View integration" onClick={() => preview(row["Sheet URL"])}>
            <VisibilityIcon />
          </IconButton>
        )}

        {row['Status'] === "ACTIVE" ? (
          <IconButton aria-label="pause integration" onClick={() => onStatusChange(row["Integration Name"], "INACTIVE")}>
            <PauseIcon />
          </IconButton>
        ) : (
          <IconButton
            aria-label="Resume integration"
            onClick={() => {
              integrationTypeNumber == 0
                ? alert("Please verify your sheet access")
                : onStatusChange(row["Integration Name"], "ACTIVE");
            }}
          >
            <PlayArrowIcon />
          </IconButton>
        )}

        {showVerify && (
          <IconButton
            aria-label="Verify integration"
            onClick={() => {
              integrationTypeNumber == 0
                ? onVerify(row["Sheet ID"], row["Integration Name"], row["Sheet Name"])
                : onFBVerify(row["Integration Name"]);
            }}
          >
            {row["Status"] === "INACTIVE" ? (
              <VerifiedUserIcon />
            ) : (
              <VerifiedUserIcon style={{ color: "green" }} />
            )}
          </IconButton>
        )}
      </>
    )}
  </Box>
</TableRow>

            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} count={count} />
    </Paper>
  );
};

export default DynamicTable;
